'use strict';

var Animation = require('./Animation.cjs.js');
var easing = require('./utils/easing.cjs.js');



exports.Animation = Animation.Animation;
exports.getEasingFunction = easing.getEasingFunction;
